export function isDefined<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

interface IsDefinedProps<T> {
  value: T;
  comment?: string;
  children: (defined: NonNullable<T>) => JSX.Element;
}

export function IsDefined<T>({ children, value }: IsDefinedProps<T>) {
  return isDefined(value) ? children(value) : null;
}
